const ISLAND_STYLES = "astro-island,astro-slot,astro-static-slot{display:contents}";
export {
  ISLAND_STYLES
};
